import React from 'react';
import {SectionNotification, SectionNotificationType} from 'wix-ui-tpa';
import Alert from 'wix-ui-icons-common/on-stage/Alert';
import Error from 'wix-ui-icons-common/on-stage/Error';
import {Severity, Violation} from '@wix/wixstores-graphql-schema-node';
import {SanitizeInnerHTMLWrapper} from '@wix/wixstores-client-common-components';
import s from './ViolationNotification.scss';

export enum ViolationNotificationDataHook {
  Root = 'ViolationNotificationDataHook.Root',
  Message = 'ViolationNotificationDataHook.Message',
}

export interface ViolationNotificationProps {
  violation: Violation;
}

export const ViolationNotification = ({violation}: ViolationNotificationProps) => {
  const type = violation.severity === Severity.ERROR ? SectionNotificationType.error : SectionNotificationType.alert;
  const Icon = violation.severity === Severity.ERROR ? Error : Alert;
  const iconClassName = violation.severity === Severity.ERROR ? s.errorIcon : s.alertIcon;

  return (
    <SectionNotification type={type} data-hook={ViolationNotificationDataHook.Root}>
      <SectionNotification.Icon icon={<Icon className={iconClassName} />} />
      <SectionNotification.Text>
        <SanitizeInnerHTMLWrapper innerHtml={violation.description}>
          <div data-hook={ViolationNotificationDataHook.Message} />
        </SanitizeInnerHTMLWrapper>
      </SectionNotification.Text>
    </SectionNotification>
  );
};
